import { render, staticRenderFns } from "./BasePreview.vue?vue&type=template&id=d508815c&scoped=true&"
import script from "./BasePreview.vue?vue&type=script&lang=js&"
export * from "./BasePreview.vue?vue&type=script&lang=js&"
import style0 from "./BasePreview.vue?vue&type=style&index=0&id=d508815c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d508815c",
  null
  
)

export default component.exports